import React, { useEffect, useState, useContext } from 'react';
import { LanguageContext } from '../../services/LanguageContext';
import { translateText } from '../../services/deeplTranslationService'; 
import '../home/home.scss';

const IOSInvitation = () => {
    const { language } = useContext(LanguageContext); 
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [heroTitle, setHeroTitle] = useState('Finden Sie Ihren perfekten Partner'); // Default in German
    const [emailNotice, setEmailNotice] = useState('Leider unterstützt der Apple AppStore keine Beta-Versionen. Dennoch können Sie unsere App bereits testen, indem Sie sich für unsere Tester-Liste registrieren. Geben Sie einfach Ihre Mail-Adresse an und werden Sie bereits heute Nutzer von Find-Together!'); // Default in German
    const [notifyMeButton, setNotifyMeButton] = useState('Registrieren'); // Default in German
    const [successMessage, setSuccessMessage] = useState('Vielen Dank! Sie werden eine TestFlight-Einladung per E-Mail erhalten.'); 

    useEffect(() => {
        // Only translate if language is not German
        if (language !== 'DE') {
          const translateTexts = async () => {
            const translatedHeroTitle = await translateText('Find Your Perfect Partner', language);
            const translatedEmailNotice = await translateText('Unfortunately, the Apple AppStore does not support beta versions. However, you can still test our app by registering for our tester list. Simply enter your e-mail address and become a Find-Together user today!', language);
            const translatedNotifyMeButton = await translateText('Register', language);
            const translatedSuccessMessage = await translateText('Thank you! You will be get TestFlight invitation through email.', language);
    
            setHeroTitle(translatedHeroTitle);
            setEmailNotice(translatedEmailNotice);
            setNotifyMeButton(translatedNotifyMeButton);
            setSuccessMessage(translatedSuccessMessage);
    
          };
    
          translateTexts();
        }
      }, [language]);

      const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://find-together-api.sslbeta.de/api/Support/notifyFutureSubscriber?email=${encodeURIComponent(email)}`, {
                method: 'POST',
                headers: {
                    'accept': '*/*',
                },
                body: '', 
            });
    
            if (response.ok) {
                console.log('Email submitted successfully');
                setSubmitted(true); 
            } else {
                console.error('Failed to submit email');
            }
        } catch (error) {
            console.error('Error occurred while submitting email', error);
        }
    };  

    return (
        <>
        <div className="hero-section">
      <div className="hero-overlay d-flex flex-column align-items-center justify-content-center">
        <h2 className='text-white'>{heroTitle}</h2>
        <span className='hero--ios-text-margin'> </span>
        <div className="notify-section">
          <p className="email-notice mt-2">{emailNotice}</p>
          {!submitted ? (
            <form onSubmit={handleSubmit} className="notify-input-container">
              <input
                type="email"
                placeholder="E-mail"
                className="custom-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="custom-button">{notifyMeButton}</button>
            </form>
          ) : (
            <p>{successMessage}</p>
          )}
        </div>
      </div>
    </div>
        </>
    );
};

export default IOSInvitation;
